<span class="italicText" *ngIf="params.value == 1">{{ "invoicePrice.dashboard.processingLabel" | translate }}</span>
<span class="greenText" *ngIf="params.value == 2">{{ "invoicePrice.dashboard.readyToDnlLabel" | translate }}</span>
<span class="blueText" *ngIf="params.value == 3">{{ "invoicePrice.dashboard.refReqLabel" | translate }}</span>

